import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';
import IconButton from 'material-ui/IconButton';
import Close from 'material-ui-icons/Close';

const styles = () => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 5px 8px 15px',
    background: '#ECEEF0',
    border: '1px solid #D8DBDF',
    width: 'max-content',
    position: 'relative'
  },

  btn: {
    padding: '0px 10px',
    minHeight: 'unset',
    minWidth: 'unset',
    fontSize: '13px',
  },

  iconBtn: {
    minHeight: 'unset',
    minWidth: 'unset',
    width: 'unset',
    height: 'unset',
    marginRight: '5px',
    marginLeft: '15px',
  },
});

class WarningLabel extends React.Component {
  state = {
  };

  render() {
    const { classes, Icon, text, color, backgroundColor, borderColor, controls, onClick, onClose } = this.props;
    const style = this.props.style ? this.props.style : {};

    return (
      <div
        className={classes.root}
        style={{
          background: backgroundColor,
          borderColor: borderColor,
          ...style
        }}
      >
        <Icon color={color} width={15} height={15} style={{ marginRight: '6px' }} />
        <Typography
          variant="body2"
          style={{ color: color, cursor: onClick ? 'pointer' : 'auto' }}
          onClick={onClick}
        >
          {text}
        </Typography>
        {controls.map((c, i) => {
          if (i === controls.length - 1) {
            return (
              <Button
                key={i}
                className={classes.btn}
                onClick={c.func}
                style={{ color: "#1A65FF" }}
              >
                {c.text}
              </Button>
            )
          } else {
            return (
              <Button
                key={i}
                className={classes.btn}
                onClick={c.func}
                style={{
                  color: '#1A65FF',
                  borderRight: `1px solid ${borderColor}`,
                  marginLeft: i === 0 ? '25px' : '0'
                }}
              >
                {c.text}
              </Button>
            )
          }
        })}
        {onClose && (
          <IconButton onClick={onClose} className={classes.iconBtn}>
            <Close width='20' height='20' style={{ fontSize: '16px', color: color }} />
          </IconButton>
        )}
      </div>
    )
  }
}

WarningLabel.propTypes = {
  classes: PropTypes.object.isRequired,
  style: PropTypes.object,
  text: PropTypes.string.isRequired,
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  borderColor: PropTypes.string,
  controls: PropTypes.array,
  onClick: PropTypes.func,
  onClose: PropTypes.func,
  Icon: PropTypes.any,
};

WarningLabel.defaultProps = {
  color: '#5A5B62',
  backgroundColor: '#ECEEF0',
  borderColor: '#D8DBDF',
  controls: [],
};

export default withStyles(styles)(WarningLabel);



// WEBPACK FOOTER //
// ./src/components/AddressBook/WarningLabel.jsx